// src/components/Contact.js
import React, { useState } from "react";
import "./contact.css";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, company, subject, message } = formData;

    const emailBody = `
Name: ${name}
Company: ${company || "-"}
Subject: ${subject}

${message}
    `;

    const mailtoLink = `mailto:shamshine66@gmail.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(emailBody)}`;

    window.location.href = mailtoLink;
  };

  return (
    <div className="contact-page">

      {/* ================= HEADER ================= */}
      <section className="contact-hero">
        <h1>Contact Us</h1>
        <p>
          Get in touch with us for enquiries, quotations, or to discuss
          your upcoming renovation or construction needs.
        </p>
      </section>

      {/* ================= CONTENT ================= */}
      <section className="contact-content">
        <div className="contact-grid">

          {/* ---------- CONTACT INFO ---------- */}
          <div className="contact-info">
            <div className="contact-card">
              <h3>Phone</h3>
              <p>
                <a href="tel:+6590684745">+65 9068 4745</a>
              </p>
            </div>

            <div className="contact-card">
              <h3>Email</h3>
              <p>
                <a href="mailto:pang@shamshine.sg">
                  pang@shamshine.sg
                </a>
              </p>
            </div>

            <div className="contact-card">
              <h3>Address</h3>
              <p>
                190 Woodlands Industrial Park E5<br />
                #06-12, Singapore 757516
              </p>
            </div>
          </div>

          {/* ---------- FORM ---------- */}
          <div className="contact-form">
            <h3>Send an Enquiry</h3>

            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="company"
                  placeholder="Company Name"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>

              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />

              <textarea
                name="message"
                placeholder="Write your enquiry here..."
                value={formData.message}
                onChange={handleChange}
                required
              />

              <button type="submit">Submit Enquiry</button>
            </form>
          </div>

        </div>
      </section>

    </div>
  );
}
